// cohorts/list types: Zod schemas are the contract, parsed at the service boundary.
// Shape of `GET /cohorts/` (cohorts-v1.md), checked against the backend code on 4 Nov 2026.
import { z } from "zod";
import { CohortSchema } from "../../_shared/types";

export const CohortListSchema = z.object({
  count: z.number(),
  next: z.string().nullable(),
  previous: z.string().nullable(),
  results: z.array(CohortSchema),
  /** Unfiltered counts for the account's scope. */
  counts: z.object({
    all: z.number(),
    preparing: z.number(),
    archived: z.number(),
  }),
  /** Page level: `create` is true only for the President. */
  available_actions: z.record(z.string(), z.boolean()),
  server_now: z.string(),
});

export type CohortList = z.infer<typeof CohortListSchema>;
